import { INDICATOR_DIRECTLY } from './../../categories/categories.page';
import { AlertService } from './../../../../../services/alert/alert.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { KpiService } from 'src/app/services/kpi/kpi.service';
import { RouterService } from 'src/app/services/router/router.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';

@Component({
  selector: 'app-indicator',
  templateUrl: './indicator.page.html',
  styleUrls: ['./indicator.page.scss'],
})
export class IndicatorPage implements OnInit {
  title
  sub_title

  IndicatorId
  categoryId
  pageBack

  labels = []
  histogram_value
  rankingBtn

  indicator
  hasRanking = false
  constructor(
    public languageService: LanguagesService,
    private activatedRoute: ActivatedRoute,
    private router: RouterService,
    private kpiService: KpiService,
    private storageService: StorageService

  ) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(async (params) => {
      this.IndicatorId = params.idIndicator
      this.categoryId = params.idCategory
      this.pageBack = this.router.getPreviousUrl()?.includes('home')   
      ? 'app/home' 
      : `app/kpi/categories/${this.categoryId}/indicators`
      
      this.getinfoIndicator(params.idIndicator);
    });
  }

  async getinfoIndicator(id) {
    this.labels = []
    const dataKpi = await this.kpiService.getKpisUrl(id);
    dataKpi.subscribe((data: any) => {
      const kpi = data;
      kpi.KpiInputs = [];
      if (kpi.kpi_config.inputs_config && kpi.inputs) {
        const inputsConfig = kpi.kpi_config.inputs_config;
        const inputs_config_sort: [] = inputsConfig ? inputsConfig?.sort((a, b) => (parseInt(a["position"]) - parseInt(b["position"]))) : [];

        inputs_config_sort.forEach((input: any, index) => {
          const object = { id: input.id, name: input.name, value: '', position: index }
          const value = kpi.inputs.find((inputValue) => { return inputValue.id == input.id })?.value

          object.value = value ? value : 0
          if (value) {
            kpi.KpiInputs.push(object)
          }


        })
      }

      if (kpi.kpi_config.labels_config && kpi.labels) {
        const labelsConfig = kpi.kpi_config.labels_config;
        const labels_config_sort: [] = labelsConfig ? labelsConfig?.sort((a, b) => (parseInt(a["position"]) - parseInt(b["position"]))) : [];
        labels_config_sort.forEach((input: any, index) => {
          const object = { id: input.id, name: input.name, value: '', position: index }
          const value = kpi.labels.find((inputValue) => { return inputValue.id == input.id })?.value

          object.value = value ? value : 0
          if (value) {
            this.labels.push(object)
          }
        })
      }

      const histogram = [...kpi.kpi_ranking]
      kpi.kpi_ranking = histogram ? histogram.sort((a, b) => (new Date(a['date']).valueOf()   - new Date(b['date']).valueOf())).map((element)=> {
        element.viewPercent = (kpi.kpi_config.histogram_value == 'value_percentage') || (kpi.kpi_config.histogram_value   == 'accumulated_percentage')
        element.valueElement = parseFloat(element[kpi.kpi_config.histogram_value]) ;
        return element}) : []
      const ranking = [...kpi.kpi_config.ranking]
      kpi.kpi_config.ranking = ranking ? ranking
      .filter((item)=> item.enabled) : []

      this.indicator = kpi
      console.log("kpi == ",kpi);
      this.title =  this.getTextsIUPageKpi.indicatorDetailsPage?.title ? this.getTextsIUPageKpi.indicatorDetailsPage?.title : kpi.kpi_config?.description
      this.sub_title = this.title ==  this.getTextsIUPageKpi.indicatorDetailsPage?.title ? kpi.kpi_config?.description : undefined
    })

  }



  setTextButtonsRanking(type) {
    switch (type) {
      case 'value':
        return 'Ver Ranking por Valor'
        break;
      case 'value_percentage':
        return 'Ver Ranking por Valor Porcentual'
        break;
      case 'accumulated':
        return 'Ver Ranking por Acumulado'
        break;
      case 'accumulated_percentage':
        return 'Ver Ranking por % Acumulado'
        break;

      default:
        return ''
        break;
    }
  }

  goToRanking(type) {
    this.router.redirect(`app/kpi/categories/${this.categoryId}/indicators/indicator/${this.IndicatorId}/ranking/${type}`)
  }

  get getTextsIUPageKpi() {
    return this.languageService.textsIU.page_kpi;
  }

}
